<template>
  <div class="bg-grey py-5">
    <div class="container">
      <div class="row">
        <div class="col-11 col-md-5 mx-auto">
          <u-animate-container>
            <u-animate
              name="fadeInUp"
              delay="0s"
              duration="1s"
              :iteration="1"
              :offset="-50"
              animateClass="animated"
              :begin="false"
            >
            <h2 class="serif col-blue mb-5">
              Contact your Agent
              <hr class="border-blue">
            </h2>
            </u-animate>
          </u-animate-container>
        </div>
      </div>
      <div class="row d-flex justify-content-center">
        <div class="person-card col-11 col-md-5 mb-5" v-for="(agent,index) in agents" :key="index">
          <u-animate-container>
            <u-animate
              name="fadeInUp"
              delay="0s"
              duration="1s"
              :iteration="1"
              :offset="-50"
              animateClass="animated"
              :begin="false"
            >
              <div class="thumbnail-wrapper">
                <img :src="agent.image" alt="" class="w-100">
              </div>
              <div class="person-details border-grey_dark bg-white">
                <div class="name">
                  <h2 class="serif col-blue mt-3">
                    {{ agent.name }}
                  </h2>
                </div>
                <div class="position">
                  <p class="col-grey_dark">
                    {{ agent.position }}
                  </p>
                </div>
                <div class="grid-x grid-margin-x">
                  <div class="row w-80 mx-auto bt-grey_dark">
                    <div class="col-12 col-md-6 my-2">
                      <div class="call-person">
                        <div class="person-icon">
                          <phoneIcon />
                        </div>
                        <p class="col-blue text-left">
                          {{ agent.phone }}
                        </p>
                      </div>
                    </div>
                    <div class="col-12 col-md-6 my-2">
                      <div class="email-person">
                        <div class="person-icon">
                          <emailIcon />
                        </div>
                        <p class="col-blue text-left">
                          Email Agent
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </u-animate>
          </u-animate-container>
        </div>


      </div>
    </div>
  </div>

</template>

<script>
import emailIcon from '@/assets/core/email.svg';
import phoneIcon from '@/assets/core/phone.svg';

export default {

  name: 'AddressAndInfo',
  components: {
    emailIcon,
    phoneIcon
  },
  data() {
    return {
      agents: [],

    }
  },
  created() {
    this.agents = this.$store.getters.getAgents

  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  .person-icon {
    width: 16px;
    float: left;
    margin-right: 10px;
  }

</style>
